import OwButton from "../OwButton/OwButton";
import OwLabel from "../OwLabel/OwLabel";

type Props = {
    message: string;
    cancelFn: () => void;
    confirmFn: () => void;
    confirmTitle?: string;
    cancelTitle?: string;
    confirmClassName?: string;
    cancelClassName?: string;
};

const SimpleConfirmModal = (props: Props) => {
    return (
        <div className="SimpleConfirmModal p-3">
            <div className={"message mb-4"}>
                <OwLabel title={props.message} />
            </div>

            <div className={"d-flex justify-content-center gap-2"}>
                <OwButton
                    title={props.confirmTitle || "confirm"}
                    className={props.confirmClassName || "btn-primary"}
                    fn={props.confirmFn}
                />
                <OwButton title={props.cancelTitle || "cancel"} className={props.cancelClassName || "btn-danger"} fn={props.cancelFn} />
            </div>
        </div>
    );
};

export default SimpleConfirmModal;
